__turbopack_context__.v({
  "block": "pA5TmW_block",
  "blockTitle": "pA5TmW_blockTitle",
  "content": "pA5TmW_content",
  "missingData": "pA5TmW_missingData",
  "root": "pA5TmW_root",
});
